import styled from 'styled-components';

export const BannerWrapper = styled.div`
  width: 100%;
  max-width: 960px;
  aspect-ratio: 960 / 278;
  height: auto;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 24px;
  -webkit-user-select: none;
  user-select: none;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    height: auto;
    max-width: 100%;
  }

  /* Swiper Pagination (Dots/Bullets) */
  .swiper-pagination {
    position: absolute !important;
    bottom: 22px !important;
    left: 0 !important;
    right: 0 !important;
    text-align: center !important;
    z-index: 10 !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    gap: 4px !important;
    -webkit-user-select: none;
    user-select: none;
  }

  .swiper-pagination .swiper-pagination-bullet {
    margin-right: 10px !important;
    display: block !important;
    width: 12px !important;
    height: 12px !important;
    border: 2px solid rgb(255, 255, 255) !important;
    border-radius: 6px !important;
    background: rgb(41, 42, 44) !important;
    opacity: 0.6 !important;
    cursor: pointer !important;
    transition: opacity 0.3s !important;
    -webkit-user-select: none;
    user-select: none;
  }

  .swiper-pagination .swiper-pagination-bullet-active {
    width: 40px !important;
    height: 12px !important;
    opacity: 1 !important;
    background: rgb(250, 88, 81) !important;
  }

  /* Swiper Navigation Arrows */
  .swiper-button-prev,
  .swiper-button-next {
    max-width: fit-content !important;
    padding: 20px !important;
    opacity: 0.6 !important;
    border-radius: 30px !important;
    width: 36px !important;
    height: 36px !important;
    background-color: rgb(41, 42, 44) !important;
    border-color: rgb(41, 42, 44) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    transition: opacity 0.3s !important;
    -webkit-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
    touch-action: manipulation;

    &::after {
      font-size: 20px !important;
      color: ${({ theme }) => theme.palette.white} !important;
      font-weight: bold !important;
    }
  }

  .swiper-button-prev {
    left: 12px !important;
  }

  .swiper-button-next {
    right: 12px !important;
  }

  .swiper-button-disabled {
    opacity: 0.3 !important;
    cursor: not-allowed !important;
  }

  /* Banner link - hover yok, sadece tıklanabilir */
  a {
    display: block;
    width: 100%;
    height: 100%;
    line-height: 0;
    transition: none;
    -webkit-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
    touch-action: manipulation;

    &,
    * {
      -webkit-user-select: none;
      user-select: none;
    }

    &:hover {
      opacity: 1;
      transform: none;
    }
  }

  /* Next.js Image wrapper */
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    -webkit-user-drag: none;
    -webkit-user-select: none;
    user-select: none;
    pointer-events: none;
  }
`;

export const BannerDetailWrapper = styled.div`
  width: auto;
  height: 300px;
  position: relative;
  *,
  after,
  before {
    box-sizing: border-box;
    border-radius: 8px;
  }
`;
